// Google Ads conversion tracking helper
export const CONV = {
  preventivo: "AW-18381959122/nwm-CKbQqIodENLfmb1E",
  contatto: "AW-18381959122/tMKRCKzQqIodENLfmb1E",
};

export function trackConversion(sendTo, value = 1.0, currency = "EUR") {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: sendTo, value, currency });
    }
  } catch (e) {
    /* no-op */
  }
}
